import React from 'react';
import { useNavigate } from 'react-router-dom';
import SeoMeta from '../SeoMeta/SeoMeta';
import Header from '../Header/Header';
import { isEduPortal } from '../../config/eduHost';
import LandingAppStoreFooter from '../../features/apps/components/LandingAppStoreFooter';
import './NotFoundPage.css';

export default function NotFoundPage() {
  const navigate = useNavigate();

  const quickLinks = [
    {
      title: 'LNAT Law Prep',
      desc: 'Section A verbal deduction & Section B law essay tutor',
      url: 'https://ivoriai.com/edu/lnat',
      route: '/lnat',
      badge: 'Law Admissions'
    },
    {
      title: 'TMUA Math Prep',
      desc: 'Paper 1 applications & Paper 2 formal logic proofs',
      url: 'https://ivoriai.com/edu/tmua',
      route: '/tmua',
      badge: 'Math & CS'
    },
    {
      title: 'UCAT Aptitude Engine',
      desc: 'Timed speed reasoning & clinical judgment scenarios',
      url: 'https://ivoriai.com/edu/ucat',
      route: '/ucat',
      badge: 'Medicine'
    },
    {
      title: 'LSAT Logic Games',
      desc: 'Formal analytical logic games & argument flaw analysis',
      url: 'https://lsat.edu.ivoriai.com/',
      route: '/lsat',
      badge: 'Legal Reasoning'
    },
    {
      title: 'Interactive Apps Store',
      desc: 'In-browser Pyodide Python lab, DCF modeling & case sandboxes',
      url: 'https://ivoriai.com/edu/apps',
      route: '/apps',
      badge: 'App Store'
    },
    {
      title: 'LLM AI Directory',
      desc: 'Machine-readable AI specifications & knowledge graph',
      url: '/llms.txt',
      route: '/llms.txt',
      badge: 'AI Index',
      isExternal: true
    }
  ];

  const handleNavigate = (link) => {
    if (link.isExternal) {
      window.location.href = link.url;
    } else if (
      // On the edu portal (ivoriai.com/edu, pathbuddy.com, legacy edu hosts) the
      // router already knows the route, basename included.
      !isEduPortal() &&
      (window.location.hostname.includes('ivoriai.com') || window.location.hostname.includes('ivori.ai')) &&
      !window.location.hostname.startsWith('edu') &&
      !window.location.hostname.startsWith('www')
    ) {
      // On exam subdomains, redirect cleanly to the target URL
      window.location.href = link.url;
    } else {
      navigate(link.route);
    }
  };

  return (
    <div className="not-found-page-root">
      <SeoMeta
        title="404 — Page Not Found | ivori AI"
        description="The requested page could not be found on ivori. Explore our LNAT prep, TMUA prep, UCAT prep, and interactive case study sandboxes."
        keywords="ivori 404, lnat prep, tmua prep, ucat prep, case study sandbox"
      />
      <Header variant="landing" />

      <main className="not-found-main-content">
        <div className="not-found-container">
          <div className="not-found-badge">
            <span className="badge-dot"></span> 404 — Navigation Signal Lost
          </div>

          <h1 className="not-found-title">
            Page Not Found. Let's Guide You Back to <span className="yellow-marker">Active Intelligence.</span>
          </h1>

          <p className="not-found-subtitle">
            The route or resource you requested may have moved or evolved. Explore our core exam prep suites, interactive case sandboxes, or AI discovery index below.
          </p>

          <div className="not-found-cards-grid">
            {quickLinks.map((link, idx) => (
              <div 
                key={idx} 
                className="not-found-card" 
                onClick={() => handleNavigate(link)}
                role="button"
                tabIndex={0}
              >
                <div className="not-found-card-top">
                  <span className="not-found-card-badge">{link.badge}</span>
                  <svg className="not-found-arrow-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h3 className="not-found-card-title">{link.title}</h3>
                <p className="not-found-card-desc">{link.desc}</p>
              </div>
            ))}
          </div>

          <div className="not-found-actions">
            <button className="not-found-primary-btn" onClick={() => navigate('/login')}>
              Sign In to Your Workspace
            </button>
            <button className="not-found-secondary-btn" onClick={() => navigate('/')}>
              Return to Ecosystem Home
            </button>
          </div>
        </div>
      </main>

      <LandingAppStoreFooter />
    </div>
  );
}
